import React from 'react';
import styles from './Chip.module.css';

const Chip = ({
  label,
  selected = false,
  disabled = false,
  onClick,
  className,
  ...props
}) => {
  const chipClasses = [
    styles.chip,
    selected && styles.selected,
    disabled && styles.disabled,
    className
  ].filter(Boolean).join(' ');

  const handleClick = (e) => {
    if (!disabled && onClick) {
      onClick(e);
    }
  };

  return (
    <div
      className={chipClasses}
      onClick={handleClick}
      role="button"
      tabIndex={disabled ? -1 : 0}
      {...props}
    >
      <span className={styles.label}>{label}</span>
    </div>
  );
};

const ChoiceChipGroup = ({
  chips = [],
  disabled = false,
  value,
  onChange,
}) => {
  const handleChipClick = (chipValue) => {
    if (disabled) return;
    onChange?.(chipValue);
  };

  return (
    <div className={styles.chipGroup}>
      {chips.map((chip) => (
        <Chip
          key={chip.value}
          label={chip.label}
          selected={value === chip.value}
          disabled={disabled || chip.disabled}
          onClick={() => handleChipClick(chip.value)}
        />
      ))}
    </div>
  );
};

const FilterChipGroup = ({
  chips = [],
  disabled = false,
  value = [],
  onChange,
}) => {
  const handleChipClick = (chipValue) => {
    if (disabled) return;
    
    const newValue = value.includes(chipValue)
      ? value.filter(v => v !== chipValue)
      : [...value, chipValue];
    
    onChange?.(newValue);
  };

  return (
    <div className={styles.chipGroup}>
      {chips.map((chip) => (
        <Chip
          key={chip.value}
          label={chip.label}
          selected={value.includes(chip.value)}
          disabled={disabled || chip.disabled}
          onClick={() => handleChipClick(chip.value)}
        />
      ))}
    </div>
  );
};

export { Chip, ChoiceChipGroup, FilterChipGroup }; 